import { Classes, Icon } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { useAuth } from "@/components/lib/auth";
import { ScenariosSlider } from "@/components/pages_logged_in/roleplays/scenarios/ScenariosSlider";
import { PlaybookSvg } from "@/components/pieces/icons/svg/playbook";
import { BRAND_PURPLE } from "@/css/constants";
import { QueryScenariosOrderBy } from "@/graphql";

export function ForYouScenarios({ pageLoading = false }) {
  const { currentWorkspace } = useAuth();
  if (pageLoading) {
    return (
      <Box>
        <Box height={31} width={100} mb={16} className={Classes.SKELETON} />
        <Box height={250} mb={16} className={Classes.SKELETON} />
        <Box height={250} mb={16} className={Classes.SKELETON} />
      </Box>
    );
  }

  return (
    <Box>
      <Box fontSize={24} fontWeight={600}>
        For You
      </Box>

      {!currentWorkspace.isPersonal && (
        <ScenariosSlider
          icon={<PlaybookSvg size={16} color={BRAND_PURPLE} />}
          title="Assigned Scenarios"
          scenarioType="assigned"
        />
      )}

      <ScenariosSlider
        icon={<Icon size={16} icon={"clean"} color={BRAND_PURPLE} />}
        title="Personal Scenarios"
        scenarioType="personal"
        orderBy={QueryScenariosOrderBy.CreatedAtDesc}
      />
    </Box>
  );
}
